import VisualizarAtendimento from '../components/VisualizarAtendimento.vue'

let routes = {
    path: '/paciente',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/visualizar-atendimento/:id?',
            name: 'VisualizarAtendimento',
            component: VisualizarAtendimento
        },
    ]
};


export default routes


// WEBPACK FOOTER //
// ./src/router/visualizar-atendimento.js